import React from 'react';
import { observer } from 'mobx-react-lite';
import { Pagination } from '@mui/material';

interface Props {
    loading: boolean;
    count: number;
    page: number;
    handleChange: (event: React.ChangeEvent<unknown>, value: number) => void
}


// const useStyles = makeStyles((theme) =>
//     createStyles({
//         root: {
//             '& > * + *': {
//                 marginTop: theme.spacing(2)
//             },
//         },
//     }),
// );

export default observer(function PaginationControlled({ loading, page, count, handleChange }: Props) {


    return (
        <div>
            <Pagination count={count} page={page} onChange={handleChange} color="primary"/>
        </div>
    );
});
